import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
// import CloseIcon from "@mui/icons-material/Close";
import { myProfileAddValidator } from "../../../services/validatior/formValidator/myProfileAccounValidator";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useState } from "react";
import { addAddress, editAddress } from "../../../redux/reducers/authSlice";
import DropdownInput from "../DropdownInput";
import OneMapField from "../OneMapField/OneMapField";
import { toSentenceCase } from "../../../utils/commonFuncs";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

export default function AddEditAddressModal({ isOpen, setIsOpen, title, myprofile, setSelectedData, postalData }) {
    const handleClose = () => {
        // setSelectedData(null)
        setIsOpen(false);

    };
    const { user } = useSelector((state) => state.auth)

    //   const navigate = useNavigate()
    const [sortedLocations, setSortedLocations] = React.useState([])

    const dispatch = useDispatch()
    const [locations, setLocations] = useState({
        address: myprofile?.address ?? '',
        country: myprofile?.country ?? '',
        postalCode: myprofile?.postalCode ?? '',
        isPrimary: true,
        generalLocation: myprofile?.generalLocation ?? '',
        isActive: true,
        location: {
            type: "Point",
            coordinates: myprofile?.location?.coordinates
        }
    })
    const editProfileAddressFormik = useFormik({
        initialValues: myProfileAddValidator(myprofile ? myprofile : null, 'initialValues'),
        validationSchema: myProfileAddValidator(myprofile ? myprofile : null, 'validationSchema'),
        onSubmit: async (values) => {
            const apiData = {
                ...locations,
                title: values?.title,
                unitNo: values?.unitNo
            }
            if ((!!values?.title && !!locations?.generalLocation && !!locations?.postalCode)) {
                if (myprofile?._id) {
                    dispatch(editAddress({ values: apiData, cusId: user?.customer?._id ?? user?.customer, locationId: myprofile?._id, dispatch }))
                    setSelectedData && setSelectedData(null)
                    setIsOpen(false)
                }
                else {
                    dispatch(addAddress({ values: apiData, cusId: user?.customer?._id ?? user?.customer, dispatch }))
                    setIsOpen(false)
                }
            }
            else {
            }
            //   dispatch(updateAddress({values:values,dispatch:dispatch}))
            // setIsOpen(false)
        }
    })

    const handleOneMapData = (response) => {
        if (response) {
            setLocations({
                ...locations,
                address: toSentenceCase(`${response?.BLK_NO !== 'NIL' ? response?.BLK_NO : ''} ` + `${response?.ROAD_NAME !== 'NIL' ? response?.ROAD_NAME : ''}`),
                country: 'Singapore',

                postalCode: response.POSTAL,
                isPrimary: true,
                isActive: true,
                location: {
                    type: "Point",
                    coordinates: [Number(Number(response.LONGITUDE).toFixed(6)), Number(Number(response.LATITUDE).toFixed(6))]
                }
            })
            setSortedLocations(postalData.filter(item => item?.postalCode === response.POSTAL.slice(0, 2)))
            editProfileAddressFormik.setFieldValue('unitNo', toSentenceCase(`${response?.BUILDING !== 'NIL' ? response?.BUILDING : ''}`))
        }
        else {
            setLocations({
                ...locations,
                address: '',
                country: '',
                generalLocation: '',
                postalCode: '',
                isActive: true,
                location: {
                    type: "Point",
                    coordinates: []
                }
            })
            editProfileAddressFormik.setFieldValue('unitNo', ``)
            setSortedLocations([])
        }
    }

    const handleChangeAddress = (e) => {
        setLocations({ ...locations, address: e.target.value })
    }

    useEffect(() => {
        if (myprofile?.postalCode) {
            setSortedLocations(postalData.filter(item => item?.postalCode === myprofile.postalCode.slice(0, 2)))
        }
        return () => { setSelectedData && setSelectedData(null); editProfileAddressFormik.resetForm() };
    }, [])
    return (
        <React.Fragment>
            <BootstrapDialog className="editmodal-wrap"
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={isOpen}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className="editmodal-heading">
                    {title}
                </DialogTitle>
                <form onSubmit={editProfileAddressFormik.handleSubmit}>
                    <DialogContent className="edit-Modal-body" dividers> <div>
                        <div className="row">
                            {!locations?.postalCode && <span className={`pincode-txt`}>* Please add valid pincode first to get address line 1</span>}
                            <div className="col-lg-12 col-md-12">
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="email" className="form-label">
                                                    Address
                                                </label>
                                                <input
                                                    type="text"
                                                    disabled={!locations?.postalCode}
                                                    className="form-control"
                                                    onChange={handleChangeAddress}
                                                    value={locations?.address}
                                                    placeholder="Enter address"
                                                />
                                                <p className='form-error-message'>
                                                    {!locations?.postalCode ? 'Add Postalcode first' : !locations?.address ?
                                                        "This is required field" : ''}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="email" className="form-label">
                                                    Floor/unit number/Building name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="unitNo"
                                                    id="unitNo"
                                                    placeholder="#09-85 Northstar @ AMK"
                                                    onChange={editProfileAddressFormik.handleChange}
                                                    value={editProfileAddressFormik?.values?.unitNo}
                                                />

                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <OneMapField
                                                    label={'Postal Code'}
                                                    type="number"
                                                    handleOnChange={handleOneMapData}
                                                    name="postalCode"
                                                    id="postalCode"
                                                    value={locations.postalCode}
                                                />
                                                <p className='form-error-message'>
                                                    {!locations?.postalCode ?
                                                        "This is required field" : ''}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="email" className="form-label">
                                                    Country
                                                </label>
                                                <input
                                                    type="text"
                                                    disabled
                                                    className="form-control"

                                                    placeholder="Enter Country"
                                                    value={locations?.country ? "Singapore" : ""}
                                                />
                                                <p className='form-error-message'>{editProfileAddressFormik.touched.country &&
                                                    editProfileAddressFormik.errors.country}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="email" className="form-label">
                                                    Name of address *
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="title"
                                                    name="title"
                                                    placeholder="My Home"
                                                    onChange={editProfileAddressFormik.handleChange}
                                                    value={editProfileAddressFormik?.values?.title}

                                                />
                                                <p className='form-error-message'>{editProfileAddressFormik.touched.title &&
                                                    editProfileAddressFormik.errors.title}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                {/* <label htmlFor="email" className="form-label">
                                                    Location
                                                </label>

                                                <select
                                                    aria-label="Default select example"
                                                    className="form-select"
                                                    name="generalLocation"
                                                    id="generalLocation"
                                                    disabled={!locations?.address}
                                                    value={locations?.generalLocation}
                                                    onChange={(e) => {
                                                        setLocations({
                                                            ...locations,
                                                            generalLocation: e.target.value,
                                                        });
                                                        editProfileAddressFormik.setFieldValue("generalLocation", e.target.value)

                                                    }}
                                                >
                                                    {sortedLocations.map((item) => {
                                                        return (
                                                            <option value={item?.generalLocation}>
                                                                {item?.generalLocation}
                                                            </option>
                                                        );
                                                    })}
                                                </select> */}
                                                <DropdownInput
                                                    label={"Location *"}
                                                    options={sortedLocations.map((item) => {


                                                        return { value: item?.generalLocation, option: item?.generalLocation }
                                                    })}
                                                    onChange={(e) => {
                                                        setLocations({
                                                            ...locations,
                                                            generalLocation: e.target.value,
                                                        });
                                                        editProfileAddressFormik.setFieldValue("generalLocation", e.target.value)

                                                    }}
                                                    name="generalLocation"
                                                    id="generalLocation"
                                                    value={locations?.generalLocation}

                                                />
                                                <p className='form-error-message'>{!locations?.generalLocation &&
                                                    "This is required field"}</p>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-lg-12 col-md-12">
                                <div className="form-group">
                                    <label>Other Address(es)</label>
                                    <textarea
                                        name=""
                                        id=""
                                        className="form-control"
                                        placeholder="Granpa House 33 Clean Road Ave 4 Singapore 821330"
                                    ></textarea>
                                </div>
                            </div> */}
                        </div>
                    </div></DialogContent>
                    <DialogActions>
                        <Button className="btn" autoFocus type="submit">
                            Save changes
                        </Button>
                    </DialogActions>
                </form>
            </BootstrapDialog>
        </React.Fragment>
    );
}
